import React from 'react';
import { getIn } from 'formik';

import StatusMessageTemplate from './StatusMessageTemplate';
export default function ValidationStatus({ status, name }) {
    var info = getIn(status, name);
    if (!info) return null;

    return <StatusMessageTemplate message={info.description} type={info.type} />;
}
